export enum ACLType {
  Public = 'Public',
  AnonymousOnly = 'AnonymousOnly',
  Authenticated = 'Authenticated'
}
